import axios from 'axios';

import { IScientificSubdomain } from '@/shared/model/scientific-subdomain.model';

const baseApiUrl = 'api/scientific-subdomains';

export default class ScientificSubdomainService {
  public find(id: number): Promise<IScientificSubdomain> {
    return new Promise<IScientificSubdomain>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IScientificSubdomain): Promise<IScientificSubdomain> {
    return new Promise<IScientificSubdomain>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IScientificSubdomain): Promise<IScientificSubdomain> {
    return new Promise<IScientificSubdomain>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
